import React from "react";
import { Box, Paper, Grid } from "@material-ui/core";
import CommonTextEditor from "src/components/CommonTextEditor/CommonTextEditor";
import { CardItem } from "./CardItem";

interface Props {
  orderInfoData: any;
}

export const Card = ({ orderInfoData }: Props) => {
  const {
    address1,
    address2,
    category,
    location,
    ordNum,
    orderComment,
    orderStatus,
    orderType,
    poNum,
    priority,
    clientCode,
  } = orderInfoData;
  return (
    <>
      <Paper elevation={1} square>
        <Box p={2} mb={3}>
          <Grid container direction="row" xs={10} md={12}>
            <CardItem field="Address 1" value={address1} />
            <CardItem field="Address 2" value={address2} />
            <CardItem field="WO #" value={ordNum} />
            <CardItem field="WO status" value={orderStatus} />
            <CardItem field="Client ID" value={clientCode} />
            <CardItem field="Location ID" value={location} />
            <CardItem field="Category" value={category} />
            <CardItem field="Order Type" value={orderType} />
            <CardItem field="PO #" value={poNum} />
            <CardItem field="Priority" value={priority} />
            {/* <CardItem field="Order Comment" value={orderComment} asHtml /> */}
          </Grid>
          <Grid container direction="row" xs={10} md={12}>
            <Box mt={1}>
              <CommonTextEditor
                value={orderComment}
                name={"notes"}
                height={150}
                title="Service Description:"
                disabled
                showHeader
                noShowHeaderBorder
                customColor="rgba(0, 0, 0, 0.54)"
              />
            </Box>
          </Grid>
        </Box>
      </Paper>
    </>
  );
};
